import React from "react";
import { Tooltip, IconButton, Button } from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";

const DeleteFileButton = ({ file, onDelete, showButtonLabel = false }) => {
  if (showButtonLabel) {
    return (
      <Button
        variant="outlined"
        color="error"
        size="small"
        startIcon={<DeleteIcon />}
        onClick={() => onDelete ? onDelete(file.id) : null}
      >
        Delete
      </Button>
    );
  }

  return (
    <Tooltip title="Delete">
      <IconButton
        aria-label="Delete file"
        onClick={() => onDelete ? onDelete(file.id) : null}
        color="error"
      >
        <DeleteIcon />
      </IconButton>
    </Tooltip>
  );
};

export default DeleteFileButton; 